import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 24 24";
const TrackerHoursIcon = ({ size, viewBox = DEFAULT_VIEWBOX, fill = "currentColor", ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, viewBox, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.5 1C4.2 1 1.5 3.7 1.5 7C1.5 10.3 4.2 13 7.5 13C10.8 13 13.5 10.3 13.5 7C13.5 3.7 10.8 1 7.5 1ZM7.5 3C9.7 3 11.5 4.8 11.5 7C11.5 9.2 9.7 11 7.5 11C5.3 11 3.5 9.2 3.5 7C3.5 4.8 5.3 3 7.5 3ZM18.5 3C17.948 3 17.5 3.448 17.5 4V5H15.2383C15.4033 5.64 15.5 6.308 15.5 7C15.5 8.062 15.2881 9.073 14.9121 10H20.5L20.502 21H6.5V16C6.5 15.448 6.052 15 5.5 15C4.948 15 4.5 15.448 4.5 16V21C4.5 22.105 5.395 23 6.5 23H20.5C21.605 23 22.5 22.105 22.5 21V7C22.5 5.895 21.605 5 20.5 5H19.5V4C19.5 3.448 19.052 3 18.5 3ZM8.68694 4.49275C8.38805 4.32924 8.01333 4.43289 7.84097 4.72676L7.11554 5.96358C6.72309 6.63268 6.83199 7.48238 7.38049 8.03089L8.1579 8.80829C8.42562 9.07601 8.86309 9.06456 9.11643 8.78318C9.35757 8.51537 9.33972 8.10374 9.07629 7.8578L8.05078 6.90039L8.93168 5.35809C9.10653 5.05197 8.99622 4.66195 8.68694 4.49275Z",
      fill
    }
  ) });
};
export {
  TrackerHoursIcon
};
